// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2EVyG","dots":"styles_dots__23dzx","dot":"styles_dot__3b5_Y","loaderDots":"styles_loaderDots__2GaTR"};